/* HALE — navigation add-ons (catalog):
   1) smarter empty-filter state (drop the last filter / drop them all);
   2) «Нещодавно переглянуті» strip on the PDP (localStorage, >= 2 items).

   Phase 2-finish (2026-09-08):
   • chipLinks() removed — it built /collections/all?filter.p.tag=стан:<label>
     links out of «користь:» chips, i.e. a filter value that never matches;
   • the PDP branch of crumbs() removed — hale-product-v2 prints .crumbs in
     Liquid, so the JS copy could never render;
   • the mutation observer on [data-col-none] replaced by a delegated `change`
     listener on the filter container (hale-collection toggles [hidden] from
     its own per-checkbox handler, which fires before the container one);
   • no setTimeout re-run and no shopify:section:load hook — HALE.feature
     re-runs every feature on section load;
   • styles moved to assets/hale-nav-addons.css (no runtime <style>).

   2026-09-10 — БЛОК КРИХТ ПРИБРАНО ПОВНІСТЮ.
   Він малював <nav class="bcrumb"> на сторінках колекцій у вигляді
   «Головна / Усі товари» — тобто остання ланка дублювала H1, який стоїть
   рівно під нею. Після того як чіпси станів повернулись у сам каталог,
   середня ланка «Каталог» теж втратила сенс: перемикання між розділами
   відбувається чіпсами на одній сторінці.
   Стилі .bcrumb у hale-nav-addons.css залишені — вони нічого не важать і
   стануться у пригоді, якщо крихти колись захочуть повернути. */
window.HALE.ready(function () {
  'use strict';

  var H = window.HALE;

  function tmpl(name) {
    return (document.body.className || '').indexOf('template-' + name) > -1;
  }
  function isCollection() { return tmpl('collection') || tmpl('list-collections'); }
  function isProduct() { return tmpl('product'); }

  /* ================= 1. SMART EMPTY STATE ================= */
  function list(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function buildEmpty(none) {
    if (none.hidden) return;

    var checked = list('.hale [data-ffallback] input[type="checkbox"]:checked');
    var pills = list('.hale .factive .fpill:not(.fpill--reset)');

    var lastBox = checked.length ? checked[checked.length - 1] : null;
    var lastPill = pills.length ? pills[pills.length - 1] : null;
    var label = '';
    if (lastBox) {
      var sp = lastBox.parentElement && lastBox.parentElement.querySelector('span');
      label = sp ? sp.textContent.trim() : '';
    } else if (lastPill) {
      label = lastPill.textContent.replace('✕', '').trim();
    }

    none.innerHTML =
      '<div class="fempty">' +
      '<div class="fempty-h">За цими фільтрами товарів немає</div>' +
      '<div class="fempty-t">Спробуйте помʼякшити вибір — або погляньте популярне в цій категорії.</div>' +
      '<div class="fempty-btns">' +
      (label ? '<button type="button" class="fempty-btn pri" data-drop-last>Скинути «' + H.esc(label) + '»</button>' : '') +
      '<button type="button" class="fempty-btn" data-drop-all>Скинути всі фільтри</button>' +
      '</div></div>';

    var dl = none.querySelector('[data-drop-last]');
    if (dl) {
      dl.addEventListener('click', function () {
        if (lastBox) {
          lastBox.checked = false;
          lastBox.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (lastPill) {
          lastPill.click();
        }
      });
    }
    var da = none.querySelector('[data-drop-all]');
    if (da) {
      da.addEventListener('click', function () {
        var reset = document.querySelector('.hale [data-freset]') ||
                    document.querySelector('.hale .fpill--reset');
        if (reset) reset.click();
      });
    }
  }

  H.feature('nav-empty-state', function (doc) {
    if (!isCollection()) return;
    var none = doc.querySelector('.hale [data-col-none]');
    if (!none) return;

    if (none.dataset.haleWired !== '1') {
      none.dataset.haleWired = '1';
      var fb = doc.querySelector('.hale [data-ffallback]');
      if (fb) {
        fb.addEventListener('change', function () { buildEmpty(none); });
      }
    }
    buildEmpty(none);
  });

  /* ================= 2. RECENTLY VIEWED ================= */
  var RVKEY = 'hale_recent_v1';

  function readRV() {
    try { return JSON.parse(localStorage.getItem(RVKEY) || '[]'); } catch (e) { return []; }
  }
  function writeRV(a) {
    try { localStorage.setItem(RVKEY, JSON.stringify(a.slice(0, 12))); } catch (e) {}
  }
  function handleFromPath() {
    return (location.pathname.split('/products/')[1] || '').split('?')[0].split('#')[0];
  }

  function trackRV(doc) {
    var handle = handleFromPath();
    if (!handle) return;
    var t = doc.querySelector('.hale .pinfo h1');
    var img = doc.querySelector('.hale #galMain img');
    var price = doc.querySelector('.hale #btnPrice') || doc.querySelector('.hale .add-pr');
    var item = {
      h: handle,
      t: t ? t.textContent.trim() : handle,
      i: img ? (img.currentSrc || img.src) : '',
      p: price ? price.textContent.trim() : ''
    };
    var rest = readRV().filter(function (x) { return x.h !== handle; });
    rest.unshift(item);
    writeRV(rest);
  }

  function renderRV(doc) {
    var handle = handleFromPath();
    var items = readRV().filter(function (x) { return x.h !== handle && x.t; });
    if (items.length < 2) return;                /* nothing worth showing yet */

    var host = doc.querySelector('.hale .pinfo');
    if (!host || host.querySelector('.rv-strip')) return;

    var cards = items.slice(0, 8).map(function (x) {
      var im = x.i
        ? '<img src="' + H.esc(x.i) + '" alt="" loading="lazy">'
        : '<img alt="" loading="lazy">';
      return '<a class="rv-card" href="/products/' + H.esc(x.h) + '">' + im +
             '<span>' + H.esc(x.t) + '</span>' +
             (x.p ? '<em>' + H.esc(x.p) + '</em>' : '') + '</a>';
    }).join('');

    var box = doc.createElement('div');
    box.className = 'rv-strip';
    box.innerHTML =
      '<div class="rv-strip-h"><b>Нещодавно переглянуті</b>' +
      '<button type="button" data-rv-clear>Очистити</button></div>' +
      '<div class="rv-row">' + cards + '</div>';
    host.appendChild(box);
    box.querySelector('[data-rv-clear]').addEventListener('click', function () {
      writeRV([]);
      box.remove();
    });
  }

  H.feature('nav-recently-viewed', function (doc) {
    if (!isProduct()) return;
    renderRV(doc);   /* render from the previous visits first … */
    trackRV(doc);    /* … then record the current product */
  });
});